import { useEffect, useRef } from 'react';

import { action } from 'lib/actionHelpers';
import selectors from 'selectors/selectors';
import { useSelector } from 'react-redux';

const handleSetGraphLoadState = (val, loadStateKey) => {
  if (loadStateKey) {
    action('SET_GRAPH_LOAD_STATE', { [loadStateKey]: val });
  }
};

export const useReportingGraphFetch = ({ graphState, fetchData, loadStateKey, data }) => {
  const fetchDataMethod = fetchData || ((data, cb) => cb);
  const reportsDateAggregate = useSelector((state) => state.ui.filters.reportsDateAggregate);
  const triggerFetchReports = useSelector((state) => state.reporting.triggerFetchReports);
  const loading = useSelector((state) => state.reporting.reportingGraphsLoadState[loadStateKey]);
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const reportsTab = useSelector(selectors.reportsTab);

  const graphStateRef = useRef(null);
  const reportsDateAggregateRef = useRef(null);
  const reportsTabRef = useRef(null);
  const triggerFetchReportsRef = useRef(triggerFetchReports);

  useEffect(() => {
    graphStateRef.current = graphState;
    reportsDateAggregateRef.current = reportsDateAggregate;
    reportsTabRef.current = reportsTab;
    triggerFetchReportsRef.current = triggerFetchReports;
  }, [graphState, reportsDateAggregate]);

  useEffect(() => {
    if (serviceProviderId && fetchDataMethod && triggerFetchReportsRef.current === false) {
      handleSetGraphLoadState(true, loadStateKey);
      const payload = { ...graphState };
      fetchDataMethod(payload, () => handleSetGraphLoadState(false, loadStateKey));
    }
  }, [reportsTab, graphState, serviceProviderId, reportsDateAggregate]);

  useEffect(() => {
    if (triggerFetchReports === true && fetchDataMethod) {
      handleSetGraphLoadState(true, loadStateKey);
      const payload = { ...graphState };
      fetchDataMethod(payload, () => handleSetGraphLoadState(false, loadStateKey));
      action('SET_TRIGGER_REPORTING_FETCH', false);
    }
  }, [triggerFetchReports]);

  const isLoading = data && !fetchData ? false : !fetchData && !loadStateKey ? !data : loading;

  return { loading: isLoading };
};
